// ----------------------------------------------------------------------------
// Component: PDP Content Panel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import { first } from 'lodash-es';
import registerCustomElement from 'scripts/helpers/register-custom-element';
import './_pdp-content-panel.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var ROUTINE_DROPDOWN = '.routine-dropdown';
var ROUTINE_DROPDOWN_TOGGLE = '.routine-dropdown__toggle';
var ROUTINE_DROPDOWN_LIST = '.routine-dropdown__list';
var ROUTINE_CARD = '.card--routine-grid-paired';
var OPEN_CLASS = 'is-open';
var body = document.querySelector('body');
var routineDropdown = document.querySelector(ROUTINE_DROPDOWN);
var routineDropdownToggle = document.querySelector(ROUTINE_DROPDOWN_TOGGLE);
var routineDropdownList = document.querySelector(ROUTINE_DROPDOWN_LIST);
var routineCard = document.querySelectorAll(ROUTINE_CARD);
function closeRoutineDropdown(toggle, list, switcher) {
  toggle.classList.remove(OPEN_CLASS);
  list.classList.remove(OPEN_CLASS);
  switcher.classList.remove(OPEN_CLASS);
  toggle.setAttribute('aria-expanded', 'false');
}

// Close the switcher if clicking outside
body.addEventListener('click', function (event) {
  if (event.target.closest(ROUTINE_DROPDOWN_TOGGLE) === null && document.querySelector(ROUTINE_DROPDOWN_TOGGLE) != null) {
    closeRoutineDropdown(routineDropdownToggle, routineDropdownList, routineDropdown);
  }
});
class RoutineDropdown extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector('.routine-dropdown__toggle'),
      panel: this.querySelector('.routine-dropdown__list'),
      firstItem: first(this.querySelectorAll('.routine-dropdown__list-item')),
      buttonText: this.querySelector('.routine-dropdown__toggle-label')
    };
    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.elements.panel.lastElementChild.addEventListener('keydown', event => {
      if (event.keyCode == 9) {
        this.parentNode.toggleAttribute('hidden');
      }
    });
    var firstLabel = this.elements.firstItem.dataset.productLabel;
    if (firstLabel) {
      this.elements.buttonText.innerText = firstLabel;
    }
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    var product_id = event.currentTarget.parentElement.dataset.productId;
    var productLabel = event.currentTarget.parentElement.dataset.productLabel;
    var currentCard = document.querySelector(".card--routine-grid[data-product-id=\"".concat(product_id, "\"]"));
    routineCard.forEach(card => {
      card.classList.remove('is-active');
    });
    currentCard.classList.add('is-active');
    this.elements.buttonText.innerText = productLabel;
    this.hidePanel();
  }
  openSelector() {
    this.elements.panel.removeAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    requestAnimationFrame(() => {
      this.elements.panel.focus();
    });
  }
  closeSelector(event) {
    var shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
  toggleSelector() {
    var isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      this.hidePanel();
    } else {
      this.openSelector();
    }
  }
}
registerCustomElement('iam-product-routine-dropdown', RoutineDropdown);